

import Calendar from 'dijit/Calendar';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DatePicker.html?raw';
import on from 'dojo/on';
import aspect from 'dojo/aspect';
import domConstruct from 'dojo/dom-construct';
import dojoQuery from 'dojo/query';
import { DateHelpers } from "../../../more/Helpers";

class DatePicker extends compose(Calendar) {
	templateString: any = template;

	minDate: Date = null;
	maxDate: Date = null;

	showCalendarWeeks: boolean = true;

	datesWithContent: Array<Date> = null;

	private currentShownDate: Date;
	private gridNode: HTMLTableElement;
	private dateRowsNode: HTMLTableElement;
	private _date2cell: Record<string, HTMLElement & { dijitDateValue: number}>

	private decrementMonth: HTMLElement;
	private incrementMonth: HTMLElement;

	private _decrementEvent: dojo.Handle = null;
	private _incrementEvent: dojo.Handle = null;

	_onMonthSelect(month: number /* 0 - 11 */ ) {
		super._onMonthSelect.apply(this, arguments as any);

		this.currentShownDate = this.currentFocus;

		this.emit("selectmonth");
	}
	setDate(target: Date) {
		this.set("value", target);

		this.currentShownDate = target;
	}

	setMinDate(newDate: Date) {

		this.set("minDate", newDate);
	}

	setMaxDate(newDate: Date) {

		if( newDate) newDate.setHours(23, 59, 59);

		this.set("maxDate", newDate);
	}

	getShownDate(): Date {
		return this.currentShownDate;
	}
	getShownYear(): number {
		return this.currentShownDate.getFullYear();
	}

	getShownMonth(): number {
		return this.currentShownDate.getMonth();
	}

	setAppointmentDates(dates: Array<Date>) {
		this.datesWithContent = dates;

		this._populateGrid();
	}

	getClassForDate(date: Date, locale: string) {
		let cal = this.dateModule;

		let classes = "";

		if (this.minDate && this.maxDate) {
			
			if (cal.compare(date, this.minDate) >= 0 && cal.compare(date, this.maxDate) <= 0) {
				classes += "Highlighted";
			}
		}

		if (this.datesWithContent?.length) {
			for (let contentDate of this.datesWithContent) {
				if (date.getDate() == contentDate.getDate() && date.getMonth() == contentDate.getMonth()) {
					classes += " hasContent";
					break;
				}
			}
		}

		return classes;
	}

	private changeCurrentShownDate(steps: number) {
		if (!this.currentShownDate) this.currentShownDate = this.currentFocus;
		if (!this.currentShownDate) return;

		if (steps >= 1 || steps <= -1) {
			let currentDate = new Date(this.currentShownDate.valueOf());
			let currentMonth = currentDate.getMonth();
			currentDate.setMonth(currentMonth + steps);


			// auf ersten Montag im Monat setzen!
			currentDate.setDate(1);
			while (currentDate.getDay() != 1) {
				currentDate.setDate(currentDate.getDate() + 1);
			}

			
			this.currentShownDate = currentDate;
			this.emit("paging", currentDate);
			
		}

		//console.debug("changeCurrentShownDate", this.currentShownDate);

	}

	private _onClick_DecrementMonth(evt: MouseEvent) {
		
		this.changeCurrentShownDate(-1);
	}
	private _onClick_IncrementMonth(evt: MouseEvent) {
		
		this.changeCurrentShownDate(1);
	}

	private _afterPopulateControls() {
		// wird ausgef�hrt beim Navigieren
		
	}
	private _afterPopulateGrid(args) {
		// wird immer ausgef�hrt, wenn neu gezeichnet wird (nach Navigieren, nach Anpassen von currentFocus etc)

		if (!this.currentShownDate) this.currentShownDate = this.currentFocus;

		// sprachunabhaengiges data-cy mit vollem Datum (YYYY-MM-DD) auf jede Tageszelle
		if (this._date2cell) {
			let pad = (n: number) => (n < 10 ? "0" + n : "" + n);
			for (let key of Object.keys(this._date2cell)) {
				let cell = this._date2cell[key];
				if (!cell) continue;
				let d = new Date(cell.dijitDateValue);
				cell.setAttribute("data-cy", "calDatePickerDay:" + d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()));
			}
		}

		if (this.showCalendarWeeks == true) {
			this._addCalendarWeeks();
		}
	}

	private _calendarWeekNodes: Array<{
		row: number,
		node: HTMLElement
	}> = null;
	private _addCalendarWeeks() {

		
		if (this._calendarWeekNodes == null || !this._calendarWeekNodes?.length) {
			// Achtung: die erzeugten Spalten bleiben erhalten. Die Funktion nur einmal erzeugen lassen, danach nur noch beschriften!
			this._calendarWeekNodes = [];

			let targetList = dojoQuery("tr:has(th.dijitCalendarDayLabelTemplate)", this.gridNode);
			let target: HTMLElement = null;
			if (targetList.length == 1) target = targetList[0] as HTMLElement;

			if (!target) return;

			let additionalHeadCol = domConstruct.create("th", {
				className: "calendarweekHead"
			}, target, "first");


			// jetzt die KW-Spalten neben jede Datumsreihe stellen:
			targetList = dojoQuery("tr.dijitCalendarWeekTemplate", this.dateRowsNode);

			for (let i = 0; i < targetList.length; i++) {
				let weekRow = targetList[i] as HTMLElement;


				let cwCol = domConstruct.create("td", {
					className: "calendarWeekCol",
					innerHTML: "CW"
				}, weekRow, "first");

				this._calendarWeekNodes.push({
					node: cwCol,
					row: i
				});
			}
		}


		let entries = Object.keys(this._date2cell);
		
		for (let cwRowEntry of this._calendarWeekNodes) {

			let dateValue = null;
			dateValue = entries[cwRowEntry.row * 7];
			dateValue = this._date2cell[dateValue].dijitDateValue;
			
			let currentDate = new Date(dateValue);

			let cwNumber = DateHelpers.getCalendarWeekNumber(currentDate)
			cwRowEntry.node.innerHTML = cwNumber.toString();

		}
	}


	postCreate(): void {
		super.postCreate.apply(this, arguments as any);
		///
		aspect.after(this, "_populateControls", lang.hitch(this, this._afterPopulateControls));
		aspect.after(this, "_populateGrid", lang.hitch(this, this._afterPopulateGrid));

		this.setDate(new Date());

		this.datesWithContent = [];
	}

	startup(): void {
		super.startup.apply(this, arguments as any);

		if (!this._decrementEvent && this.decrementMonth) {
			this._decrementEvent = on(this.decrementMonth, "click", lang.hitch(this, this._onClick_DecrementMonth));
		}

		if (!this._incrementEvent && this.incrementMonth) {
			this._incrementEvent = on(this.incrementMonth, "click", lang.hitch(this, this._onClick_IncrementMonth));
		}

	}


}

export default mdsWidget(DatePicker);


